const translations = {
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading...',
    name: 'Name',
    noMoreAssets: 'No more assets'
};

export default translations;
